<div class="main-banner item-bg-one">
    <particles [params]="myParams" [style]="myStyle" [width]="width" [height]="height"></particles>
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="main-banner-text text-end">
                    <h4>We Are Creative</h4>
                    <h1>The Best <span>Digital</span> Experience</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <a (click)="onClick('about')" class="btn btn-primary">Get Started</a>
                    <a (click)="onClick('work')" class="btn btn-primary view-work">View Work</a>
                </div>
            </div>
        </div>
    </div>
</div>

<app-welcome></app-welcome>


<app-who-we-are></app-who-we-are>

<app-cta></app-cta>


<app-funfacts></app-funfacts>


<app-how-we-work></app-how-we-work>


<app-why-we-different></app-why-we-different>

<app-work></app-work>


<app-faq></app-faq>

<app-feedback></app-feedback>

<app-blog></app-blog>

<app-contact></app-contact>